import React from "react";
import { formatSpeed } from "@/utils/utils";
import "../css/main.css";

class Record extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      record: [],
    };
  }

  componentDidMount() {
    this.setState({
      record: JSON.parse(localStorage.getItem("testRecord")) || [],
    });
  }

  toResult = (item) => {
    sessionStorage.setItem("testResult", JSON.stringify(item));
    this.props.history.push("/result");
  };

  removeRecord = () => {
    const result = window.confirm("是否删除当前记录？");
    if (result) {
      localStorage.removeItem("testRecord");
      this.setState({
        record: [],
      });
    }
  };

  renderItem = (record) => {
    const list = [];
    for (let i = record.length - 1; i >= 0; i--) {
      const item = record[i];
      list.push(
        <tr key={item.stime} onClick={() => this.toResult(item)}>
          <td>
            <img
              className="table-icon"
              alt="wifi"
              src={
                item.netType === "wifi"
                  ? require("../images/wifi.png")
                  : item.netType === "ethernet"
                  ? require("../images/ethernet.png")
                  : require("../images/signal.png")
              }
            />
          </td>
          <td>{item.stime}</td>
          <td>{formatSpeed(item.downloadSpeed)}</td>
          <td>{formatSpeed(item.uploadSpeed)}</td>
          <td>
            <img
              className="table-icon-left"
              alt="wifi"
              src={require("../images/to_left.png")}
            />
          </td>
        </tr>
      );
    }
    return list;
  };

  render() {
    const { record } = this.state;
    const recordNum = record.length;
    return (
      <div className="main">
        <div className="container">
          <div className="nav-bar">
            <span className="nav-left"></span>
            <span className="nav-title">测速记录</span>
            <span className="nav-right">
              <img
                className="nav-icon"
                src={require("../images/trash.png")}
                alt="trash"
                onClick={this.removeRecord}
              />
            </span>
          </div>
          <table className="record-table">
            <thead>
              <tr>
                <th style={{ width: "50px" }}>类型</th>
                <th style={{ width: "90px" }}>时间</th>
                <th>下载/Mbps</th>
                <th>上传/Mbps</th>
              </tr>
            </thead>
            <tbody>{this.renderItem(record)}</tbody>
          </table>
          {recordNum > 0 && <div>-将为您保存{recordNum}条记录-</div>}
          {recordNum === 0 ? (
            <div className="center-message">暂无记录</div>
          ) : (
            ""
          )}
        </div>
        <div className="tab-bar">
          <ul>
            <li>
              <img
                src={require("../images/test_b.png")}
                alt="test"
                onClick={() => this.props.history.push("/")}
              ></img>
            </li>
            <li>
              <img src={require("../images/record_a.png")} alt="record"></img>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Record;
